import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../utils/Api';

const styles = css`
  padding-top: 20px;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  gap: 20px;
  & .welcome {
    margin: 0 auto;
    font-size: 2em;
  }
  & .greeting {
    margin: 0 auto;
  }
  & .form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    .row {
      display: flex;
      flex-wrap: wrap;
      width: 60%;
      gap:20px;
      & .col {
        min-width: 10em;
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 1;
      }
      & .label {
        padding-bottom: 20px;
      }
      &.buttons {
        flex-direction: row-reverse;
        align-items: end;
      }
    }
  }

`
const Invitations = ({ className }) => {
  const { invitation } = useParams();
  const navigate = useNavigate();

  const [invitationData, setInvitationData] = useState(null);
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);


  useEffect(() => {
    const fetchInvitation = async () => {
      const [err, invitationData] = await Api.getInvitation(invitation);
      if (err) {
        toast.error(`Unable to find your invitation: ${Api.error(err)}`)
        console.error(err.message);
      } else {
        setInvitationData(invitationData);
      }
    }

    fetchInvitation()
  }, [invitation]);

  useEffect(() => {
    const { firstname = '', lastname = '', email = '', address = '', phone = '' } = invitationData ?? {};
    setFirstname(firstname);
    setLastname(lastname);
    setEmail(email);
    setPhone(phone);
    setAddress(address);

  }, [invitationData]);

  useEffect(() => {
    let isDisabled = (!(firstname && lastname && email && password && verifyPassword));
    isDisabled = (isDisabled || (password !== verifyPassword));
    setIsDisabled(isDisabled);
  }, [firstname, lastname, email, password, verifyPassword])

  const submit = async () => {
    const [err,] = await Api.registerUser(invitation, {
      firstname,
      lastname,
      email,
      phone,
      address,
      password
    });
    if (err) {
      toast.error(`Unable to complete your registration: ${Api.error(err)}`);
      console.error(err);
    } else {
      navigate('/login', { state: { message: 'Registration successful, please login' } });
    }
  }

  return (
    <div className={className}>
      {
        invitationData &&
        <>
          <div className='welcome'>
            {`Welcome ${invitationData.firstname}!`}
          </div>
          <div className='greeting'>
            Please complete your account setup
          </div>
          <div className='form'>
            <div className='row'>
              <div className='col'>
                <div className='field'>
                  <div className='label'>
                    Email
                  </div>
                  <input placeholder='Required' disabled value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div className='field'>
                  <div className='label'>
                    First Name
                  </div>
                  <input placeholder='Required' value={firstname} onChange={e => setFirstname(e.target.value)} />
                </div>
                <div className='field'>
                  <div className='label'>
                    Last Name
                  </div>
                  <input placeholder='Required' value={lastname} onChange={e => setLastname(e.target.value)} />
                </div>
              </div>
              <div className='col'>
                <div className='field'>
                  <div className='label'>
                    Phone Number
                  </div>
                  <input placeholder='Optional' value={phone} onChange={e => setPhone(e.target.value)} />
                </div>
                <div className='field'>
                  <div className='label'>
                    Address
                  </div>
                  <input placeholder='Optional' value={address} onChange={e => setAddress(e.target.value)} />
                </div>
              </div>
              <div className='col'>
                <div className='field'>
                  <div className='label'>
                    Password
                  </div>
                  <input placeholder='Required' type='password' value={password} onChange={e => setPassword(e.target.value)} />
                </div>
                <div className='field'>
                  <div className='label'>
                    Verify Password
                  </div>
                  <input placeholder='Required' type='password' value={verifyPassword} onChange={e => setVerifyPassword(e.target.value)} />
                </div>
              </div>
            </div>
            <div className='row buttons'>
              <button disabled={isDisabled} className='primary' onClick={submit}>Register</button>
            </div>
          </div>
        </>
      }
    </div >
  )
}

export default styled(Invitations)`${styles}`;